const meta = {};

export {meta};



// WEBPACK FOOTER //
// ./app/models/meta.js